import { useMutation, useQueryClient } from "@tanstack/react-query";
import { submitHomework } from "../services/api";
import { AuthContext } from "../context/AuthContext";
import { useContext, useState } from "react";
import { Task } from "../constants/AllTypes";
import { LessonContext } from "../context/LessonContext";

export const useSendHomework = () => {
    const queryClient = useQueryClient();
    const { setHomeworkSubmitted } = useContext(LessonContext);
    const { currentUser } = useContext(AuthContext);
    const [coinAnimationData, setCoinAnimationData] = useState<{
      currentCoins: number;
      newCoins: number;
    } | null>(null);
  
    const mutation = useMutation({
      mutationFn: async (data: { taskId: string; submit: any; result: string }) => {
        return await submitHomework(data);
      },
      onSuccess: () => {
        // Refresh homework list automatically
        queryClient.invalidateQueries({ queryKey: ['studentHomework', currentUser?.userId] });
        queryClient.invalidateQueries({ queryKey: ["homeworkStats", currentUser?.userId]})
      },
      onError: (error: any) => {
        console.error('Error message:', error.response?.data?.message);
      },
    });
  
    const sendHomework = async (percentageCorrect: string, task: Task, submit: any, currentUser: any) => {
      if (currentUser?.mode === 'student' && task.isHomework) {
        const data = {
          taskId: String(task.taskId),
          submit,
          result: percentageCorrect,
          taskSettings: task.taskSettings
        };
        const locked = localStorage.getItem(`locked_${task.taskId}`) === 'true';
        if (locked) {
          console.warn('Task attempts exhausted, not sending request');
          return;
        }
  
        mutation.mutate(data, {
          onSuccess: (data) => {
            const { currentCoins, newCoins } = data;

            setCoinAnimationData({ currentCoins, newCoins });
            setHomeworkSubmitted(true);
            setTimeout(() => setHomeworkSubmitted(false), 2000);
          },
          onError: (error: any) => {
            const errorData = error.response?.data;

            if (errorData?.error === 'ATTEMPTS_EXHAUSTED') {
              // Persist locally so user won't resend requests
              localStorage.setItem(`locked_${task.taskId}`, 'true');

              // Optional: update any frontend state/context
              setHomeworkSubmitted(false); 
            } else {
              console.error('Error message:', errorData?.message);
            }
          },
        });
      }
    };
  
    return { sendHomework, coinAnimationData, ...mutation };
  };